import { ObjectValues } from 'types';
import { DealRoom } from './DealRoom';

export const SHARED_SECTION = {
  MARKETPLACE: 'marketplace',
  BEST_MATCH: 'bestMatch',
} as const;

export const DEAL_ROOM_SEARCH = {
  DRAFTS: 'drafts',
  SELLING: 'selling',
  BUYING: 'buying',
  ...SHARED_SECTION,
} as const;

export type DealRoomSearch = ObjectValues<typeof DEAL_ROOM_SEARCH>;

export const MATCH_TYPE = {
  EXACT: 'exact',
  APPROXIMATE: 'approximate',
} as const;

export type MatchType = ObjectValues<typeof MATCH_TYPE>;

export type MatchHighlight = {
  start: number;
  length: number;
};

export const MATCH_FIELD = {
  NAME: 'name',
  LISTING_NAME: 'portfolioName',
  BROKER: 'brokerNames',
} as const;

export type MatchField = ObjectValues<typeof MATCH_FIELD>;

export type MatchInfo = {
  field: MatchField;
  value: string;
  matchType: MatchType;
  highlights: MatchHighlight[];
};

export type SearchResultItem = Partial<DealRoom> & {
  matchedField?: MatchField;
  matchType?: MatchType;
  matches?: MatchInfo[];
  section?: DealRoomSearch | RwcSearchSection;
};

export type SharedSearchSections = {
  [SHARED_SECTION.MARKETPLACE]: SearchResultItem[];
  [SHARED_SECTION.BEST_MATCH]?: SearchResultItem[];
};

export type DealRoomSearchResults = SharedSearchSections & {
  [DEAL_ROOM_SEARCH.DRAFTS]: SearchResultItem[];
  [DEAL_ROOM_SEARCH.SELLING]: SearchResultItem[];
  [DEAL_ROOM_SEARCH.BUYING]: SearchResultItem[];
};

export const RWC_SEARCH_SECTION = {
  YOUR_RWC: 'yourRwcDeals',
  OTHER_RWC: 'otherRwcDeals',
  ...SHARED_SECTION,
} as const;

export type RwcSearchSection = ObjectValues<typeof RWC_SEARCH_SECTION>;

export type RwcDealRoomSearchResults = SharedSearchSections & {
  [RWC_SEARCH_SECTION.YOUR_RWC]: SearchResultItem[];
  [RWC_SEARCH_SECTION.OTHER_RWC]: SearchResultItem[];
};
